// @ts-check
// src/components/Spinner.js — Faza D.3.4 lit-html
//
// Loading spinner — uniwersalny.
// Sizes: sm (14px) | md (24px) | lg (40px)

import { html } from 'lit-html';
import { styleMap } from 'lit-html/directives/style-map.js';

const SIZES = { sm: 14, md: 24, lg: 40 };

/**
 * @param {Object} [opts]
 * @param {'sm'|'md'|'lg'} [opts.size='md']
 * @param {string} [opts.label] - opcjonalny text obok spinnera ("Ładowanie...")
 * @param {string} [opts.color='var(--color-primary)']
 * @returns {import('lit-html').TemplateResult}
 */
export function Spinner({ size = 'md', label, color = 'var(--color-primary)' } = {}) {
  const px = SIZES[size] || SIZES.md;
  const wrapStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    color: 'var(--color-text-muted)',
    fontSize: '13px',
  };
  const iconStyles = {
    width: px + 'px',
    height: px + 'px',
    color,
    animation: 'spin 1s linear infinite',
  };
  return html`
    <span style=${styleMap(wrapStyles)} role="status" aria-live="polite">
      <i data-lucide="loader-2" style=${styleMap(iconStyles)}></i>
      ${label ? html`<span>${label}</span>` : ''}
      <span class="sr-only">Ładowanie</span>
    </span>
  `;
}
